import React from 'react';

const FieldDisplay: React.FC<{
    label: string;
    value: string | React.ReactNode;
    className?: string;
    hasBorder?: boolean;
    labelClassName?: string;
}> = ({
    label,
    value,
    className = '',
    hasBorder = true,
    labelClassName = '',
}) => (
        <div className={`pb-2 ${className}`}>
            <label className={`block mb-1 ${labelClassName || 'heading-field'}`}>
                {label}
            </label>
            <div
                className={`text-sm font-medium text-gray-900 break-words pb-3 ${hasBorder ? 'border-b border-gray-200' : ''
                    }`}
            >
                {value || '-'}
            </div>
        </div>
    );

export default FieldDisplay;
